<div *ngIf = "_refreshComponent">
  <div class="p-b-10 flex flex-horiz-space-bw">
    <div></div>
    <!-- <Icon type="reload"></Icon> -->
    <div>
      <!-- <button nz-button nzType="default" (click)="refreshCorrespondence()"> <i nz-icon type="reload"></i>
        Refresh</button> -->
        <!-- Removing add correspondence button-->
      <!-- <span style="padding:0 5px"></span>
      <button nz-button nzType="primary" (click)="resetAllFields();openCorrModal()" [disabled]="!checkviewTypeAndUser()">New Correspondence</button> -->
    </div>
  </div>

  <!-- <nz-skeleton *ngIf="!commonUtilty.isArrayIterable(corList)" [nzActive]="true"></nz-skeleton> -->
  <nz-empty *ngIf="!commonUtilty.isArrayIterable(corList)" ></nz-empty>
  
  <nz-timeline *ngIf="commonUtilty.isArrayIterable(corList)">
    <nz-timeline-item nzColor="green" *ngFor="let item of corList">
      <h4 class="f-w-600">{{item.channelCd}}
        <span *ngIf="item.statusCd === 'PENDING'">
          <nz-tag [nzColor]="'orange'">Pending</nz-tag>
        </span>
        <span *ngIf="item.statusCd === 'VERIFIED'">
          <nz-tag [nzColor]="'green'">Verified</nz-tag>
        </span>
        <span *ngIf="item.statusCd === 'DISPATCHED'">
          <nz-tag [nzColor]="'blue'">Dispatched</nz-tag>
        </span>
        <span *ngIf="item.statusCd === 'CANCELED'">
          <nz-tag [nzColor]="'red'">Cancelled</nz-tag>
        </span>

        <!-- <span>
          <nz-tag>{{(item?.statusCd | technicalTranslate : 'corresStatusCd') || ''}}</nz-tag>
      </span> -->

      </h4>
      <p>
        <!-- <i class="anticon anticon-calendar"></i> -->
        <span nz-icon nzType="calendar" nzTheme="outline"></span>
        &nbsp;&nbsp; {{getDateString(item?.createdDt)}}</p>
      <p>
        <!-- <span *ngIf="item.receipent != null"> To : {{item?.receipent}}</span> <span *ngIf="item.receipent != null">
          <br></span> -->
        <span *ngIf="item.templateDesc != null">
          <a (click)="fetchMessageByGuid(item)">
            Message: {{item?.templateDesc}}
          </a>
        </span> 
        <!-- <br>
        <span *ngIf="item.clientRefGuid != null"> : {{getClienNameByGuid(item?.clientRefGuid)['name']}}</span>
         <span *ngIf="item.clientRefGuid != null"></span>
        <br>       -->
      </p>
    </nz-timeline-item>
    <!-- <nz-timeline-item nzColor="green">
        <h4 class="f-w-600">SMS <nz-tag [nzColor]="'green'">Sent</nz-tag>
        </h4>
        <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
        <p>
          To: 9809862272 <br>
          Message: Your claim is being processed
        </p>
      </nz-timeline-item> -->
  </nz-timeline>
</div>



<!-- New correspondence  [nzFooter]="showFooter" --> 
<!-- <nz-modal [(nzVisible)]="modalCorrespNew" nzTitle="New Correspondence" (nzOnCancel)="modalCorrespNew=false"
  (nzOnOk)="saveCorrespondence()" [nzOkText]="modalBtnText" [nzFooter]="modalFooter" nzWidth="75%" nzZIndex="1400"> -->
<nz-modal nzClassName="corresp-modal" [(nzVisible)]="modalCorrespNew" nzTitle="Correspondence" [nzFooter]="modalFooter" nzWidth="90%"  (nzOnCancel)="modalCorrespNew=false">
  <ng-container *nzModalContent>
    <div *ngIf="modalCorrespNew">
      <nz-radio-group [(ngModel)]="correspondenceDO.channelCd" [nzButtonStyle]="'solid'" [nzSize]="'default'"
        (ngModelChange)="modelChanged($event)">
        <label nz-radio-button nzValue="EMAIL"
          [nzDisabled]="correspondenceDO.channelCd != 'EMAIL' && correspondenceDO.templateCd !=null"><i nz-icon
            nzType="mail" theme="outline"></i> Email</label>
        <label nz-radio-button nzValue="SMS"
          [nzDisabled]="correspondenceDO.channelCd != 'SMS' && correspondenceDO.templateCd !=null"><i nz-icon
            nzType="mobile" theme="outline"></i> SMS</label>
        <label nz-radio-button nzValue="LETTER"
          [nzDisabled]="correspondenceDO.channelCd != 'LETTER' && correspondenceDO.templateCd !=null"><i nz-icon
            nzType="file-pdf" theme="outline"></i> Letters</label>
        <label nz-radio-button nzValue="WHATSAPP"
          [nzDisabled]="correspondenceDO.channelCd != 'WHATSAPP' && correspondenceDO.templateCd !=null"><i nz-icon
            nzType="mobile" theme="outline"></i> WhatsApp</label>
      </nz-radio-group>
  
      <div
        *ngIf="'EMAIL'==correspondenceDO.channelCd  || 'LETTER' == correspondenceDO.channelCd || 'INTERNALEMAIL' == correspondenceDO.channelCd">
  
        <h4 class="d-b m-t-20">To</h4>
        <!-- Multi emails; ENTER to add new entry  nzMode="tags"
  nzMode="tags"
  nzMode="tags"
  nzMode="tags"-->
  
        <!-- *ngIf="'EMAIL'==correspondenceDO.channelCd  || 'LETTER' == correspondenceDO.channelCd" -->
        <!-- <nz-select nzShowSearch style="width: 100%;" [(ngModel)]="correspondenceDO.configTo" nzDisabled>
          <nz-option [nzLabel]="correspondenceDO.configTo" [nzValue]="(correspondenceDO.configTo | technicalTranslate)"></nz-option>
        </nz-select> -->
  
        <nz-select style="width: 100%;" [(ngModel)]="correspondenceMsgDO.recipient" nzDisabled>
          <nz-option [nzLabel]="correspondenceMsgDO.recipient" [nzValue]="correspondenceMsgDO.recipient"></nz-option>
        </nz-select>
  
        <!-- <input type="text" nz-input class="w-100-pc d-b" [(ngModel)]="correspondenceDO.receipent"> -->
  
        <!-- <input *ngIf="'INTERNALEMAIL'==correspondenceDO.channelCd" nz-input  [(ngModel)]="correspondenceDO.configTo"> -->
  
        <!-- <h4 class="d-b m-t-20">CC</h4>
         Multi emails; ENTER to add new entry 
  
        <input nz-input  [(ngModel)]="correspondenceDO.cc">
  
  
        <h4 class="d-b m-t-20">BCC</h4>
         Multi emails; ENTER to add new entry 
        <nz-select nzShowSearch style="width: 100%;" [(ngModel)]="correspondenceDO.bcc">
          <nz-option *ngFor="let item of emailList" [nzLabel]="item" [nzValue]="item"></nz-option>
        </nz-select>
  
        <div class="flex flex-horiz-space-bw p-10 bg-grey-e9 m-t-20 m-b-10">
          <div class="flexie-auto-grid">
            <div>
              <small class="d-b text-a-left col-dark">Select replacement</small>
              <nz-select nzShowSearch style="width:180px" [(ngModel)]="replacementSelected"
                (ngModelChange)="replacementSelect(replacementSelected)">
                <nz-option *ngFor="let i of replacementArray" [nzLabel]="i.key" [nzValue]="i.value"></nz-option>
              </nz-select>
            </div>
            <div style="width:180px">
              <small class="d-b text-a-left col-dark">Copy-paste code</small>
              One-way bound ! 
              <input type="text" nz-input [ngModel]="replacementSelectedKaValue" name="replacement" #selectionInput
                (click)="selectionInput.select()" />
            </div>
          </div>
          <div>
            <small class="d-b text-a-left col-dark">Template</small>
            <nz-select nzShowSearch style="width:600px" [(ngModel)]="templateType"
              (ngModelChange)="modeltemplateChange($event)" [disabled] = "appMetadataHandler.featureFlags.BSLI_Config && correspondenceDO.templateCd">
              <nz-option *ngFor="let i of templateArray" [nzLabel]="i.key" [nzValue]="i.value"></nz-option> 
              <nz-option *ngFor="let item of (lookup$.cor_Templates | async) as templateLookup; trackBy:item?.lookupKey"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
            </nz-select>
          </div>
        </div> -->
  
        <div *ngIf="'EMAIL'==correspondenceDO.channelCd || 'INTERNALEMAIL' == correspondenceDO.channelCd">
          <h4 class="d-b">Subject</h4>
          <!-- [disabled]="appMetadataHandler.featureFlags.BSLI_Config" -->
          <input type="text" nz-input class="w-100-pc d-b" [(ngModel)]="correspondenceDO.subject" nzDisabled
            *ngIf="'EMAIL'==correspondenceDO.channelCd || 'INTERNALEMAIL' == correspondenceDO.channelCd">
  
        </div>
        <nz-tabset>
          <nz-tab [nzTitle]="'Email Content'"
            *ngIf="'EMAIL'==correspondenceDO.channelCd || 'INTERNALEMAIL' == correspondenceDO.channelCd">
            <angular-editor id="editEmail" [(ngModel)]="correspondenceMsgDO.body" [config]="editorConfig"
              (ngModelChange)="onBodyChange($event)"></angular-editor>
          </nz-tab>
          <nz-tab [nzTitle]="'Content'" *ngIf="'LETTER' == correspondenceDO.channelCd">
            <pdf-viewer [src]="previewDataStream" [render-text]="false" style="display: block; min-width:auto; height: 90vh;">
            </pdf-viewer>
            <!-- <ngx-extended-pdf-viewer [src]="previewDataStream" useBrowserLocale="true" style="display: block; min-width:840px"></ngx-extended-pdf-viewer> -->
          </nz-tab>
        </nz-tabset>
  
        <!-- <nz-tabset>
          <nz-tab [nzTitle]="'Email Content'">
            <angular-editor id="editEmail" [(ngModel)]="correspondenceMsgDO.body" [config]="editorConfig" (ngModelChange)="onBodyChange($event)"></angular-editor>
          </nz-tab>
          <nz-tab *ngIf = "'INTERNALEMAIL' != correspondenceDO.channelCd" [nzTitle]="'Attachment Content'">
              <angular-editor id="editEmail2" [(ngModel)]="correspondenceMsgDO.message"[config]="editorConfig" (ngModelChange)="msgChange($event)"></angular-editor>
          </nz-tab>
        </nz-tabset> -->
  
      </div>
  
      <div *ngIf="'PDF'==correspondenceDO.channelCd">
        <!-- || 'LETTER'== correspondenceDO.channelCd -->
        <!-- <h4 class="d-b m-t-20">Content</h4>
        <div class="flex flex-horiz-space-bw p-10 bg-grey-e9 m-t-20 m-b-10">
          <div class="flexie-auto-grid">
            <div>
              <small class="d-b text-a-left col-dark">Select replacement</small>
              <nz-select nzShowSearch style="width:180px" [(ngModel)]="replacementSelected"
                (ngModelChange)="replacementSelect(replacementSelected)">
                <nz-option *ngFor="let i of replacementArray" [nzLabel]="i.key" [nzValue]="i.value"></nz-option>
              </nz-select>
            </div>
            <div style="width: 180px;">
              <small class="d-b text-a-left col-dark">Copy-paste code</small>
               One-way bound ! 
              <input type="text" nz-input [ngModel]="replacementSelectedKaValue" name="replacement" #selectionInput
                (click)="selectionInput.select()" />
            </div>
          </div>
          <div>
            <small class="d-b text-a-left col-dark">Template</small>
            <nz-select nzShowSearch style="width: 600Px;" [(ngModel)]="templateType"
              (ngModelChange)="modeltemplateChange($event)">
              <nz-option *ngFor="let item of (lookup$.cor_Templates | async) as templateLookup; trackBy:item?.lookupKey"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
            </nz-select>
          </div>
        </div> -->
        <angular-editor [(ngModel)]="correspondenceMsgDO.message"></angular-editor>
      </div>
  
      <div *ngIf="'SMS'==correspondenceDO.channelCd || 'WHATSAPP'==correspondenceDO.channelCd">
        <h4 class="d-b m-t-20">To </h4>
        <!-- Multi phone nos; ENTER to add new entry -->
        <!-- Removing auto populate option: As discussed everything will be populated from config  -->
  
        <!-- <nz-select nzShowSearch style="width: 100%;" [(ngModel)]="correspondenceDO.configTo" nzDisabled> -->
        <!-- <nz-option *ngFor="let item of mobArray" [nzLabel]="item" [nzValue]="item"></nz-option> -->
        <!-- <nz-option [nzLabel]="correspondenceDO.configTo" [nzValue]="correspondenceDO.configTo"></nz-option>
        </nz-select> -->
  
        <nz-select style="width: 100%;" [(ngModel)]="correspondenceMsgDO.recipient" nzDisabled>
          <nz-option [nzLabel]="correspondenceMsgDO.recipient" [nzValue]="correspondenceMsgDO.recipient"></nz-option>
        </nz-select>
  
        <!-- <div class="flex flex-horiz-space-bw p-10 bg-grey-e9 m-t-20 m-b-10" *ngIf="appMetadataHandler.featureFlags.BSLI_Config && 'SMS' == correspondenceDO.channelCd">
          <div class="flexie-auto-grid">
            <div>
              <small class="d-b text-a-left col-dark">Select replacement</small>
              <nz-select nzShowSearch style="width:180px" [(ngModel)]="replacementSelected"
                (ngModelChange)="replacementSelect(replacementSelected)">
                <nz-option *ngFor="let i of replacementArray" [nzLabel]="i.key" [nzValue]="i.value"></nz-option>
              </nz-select>
            </div>
            <div style="width:180px">
              <small class="d-b text-a-left col-dark">Copy-paste code</small>
               
              <input type="text" nz-input [ngModel]="replacementSelectedKaValue" name="replacement" #selectionInput
                (click)="selectionInput.select()" />
            </div>
          </div>
          <div>
            <small class="d-b text-a-left col-dark">Template</small>
            <nz-select nzShowSearch style="width:600px" [(ngModel)]="templateType"
              (ngModelChange)="modeltemplateChange($event)" [disabled] = "appMetadataHandler.featureFlags.BSLI_Config && correspondenceDO.templateCd">
              <nz-option *ngFor="let i of templateArray" [nzLabel]="i.key" [nzValue]="i.value"></nz-option> 
              <nz-option *ngFor="let item of (lookup$.cor_Templates | async) as templateLookup; trackBy:item?.lookupKey"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
            </nz-select>
          </div>
        </div> -->
  
        <h4 class="d-b m-t-20">Message</h4>
        <angular-editor *ngIf="'SMS'==correspondenceDO.channelCd" [(ngModel)]="correspondenceMsgDO.message"
          [config]="editorConfig" (ngModelChange)="msgChange($event)"></angular-editor>
        <angular-editor *ngIf="'WHATSAPP'==correspondenceDO.channelCd" [(ngModel)]="whatsappMessage"
          [config]="editorConfig" (ngModelChange)="msgChange($event)"></angular-editor>
      </div>
  
    </div>
  </ng-container>
<!-- (nzOnCancel)="modalCorrespNew=false"
  (nzOnOk)="saveCorrespondence()" -->
  <ng-template #modalFooter>
      <button nz-button nzType="default" (click)="cancelCorres()">Close</button>
      <button *ngIf="correspondenceDO.channelCd != 'SMS' && correspondenceDO.channelCd != 'WHATSAPP' && correspondenceDO.channelCd != 'EMAIL'" nz-button nzType="default" (click)="showPdfPreview('Download')" [nzLoading]="downloadInProgress">Download</button>
      <!-- <button *ngIf="correspondenceDO.channelCd == 'LETTER'" nz-button nzType="default" (click)="showPdfPreview('Preview')" [nzLoading]="previInProgress">Preview</button> -->
      <!-- <button nz-button nzType="default" (click)="showPreview()">Preview</button> -->
      <!-- <button *ngIf="showFooter && correspondenceDO.statusCd == 'PENDING' && _state == 'claimCorrespondence' && checkviewTypeAndUser()" nz-button nzType="default" (click)="verifyCorres()">Verify</button> -->
      <button *ngIf="showFooter && correspondenceDO.statusCd == 'PENDING' && checkviewTypeAndUser()" nz-button nzType="default" (click)="verifyCorres()">Verify</button>
      <!-- <button *ngIf="showFooter && checkviewTypeAndUser()" nz-button nzType="primary" (click)="saveCorrespondence()" [nzLoading]="isConfirmLoading">Save</button> -->
      <!-- <button *ngIf="correspondenceDO.statusCd != 'DISPATCHED' && checkviewTypeAndUser()" nz-button nzType="primary" (click)="sendCorrespondence()" [nzLoading]="isConSendLoading">Send</button> -->
      <button *ngIf="correspondenceDO.statusCd == 'VERIFIED' && appMetadataHandler.featureFlags.PMLI_Config" nz-button nzType="default" (click)="unVerifyCorrespondenceDo()">Unverify</button>
    </ng-template>

</nz-modal>



<nz-modal [(nzVisible)]="modalPreview" nzTitle="Report Preview" (nzOnCancel)="modalPreview=false"
  (nzOnOk)="modalPreview=false" nzOkText="Ok" nzWidth="820px" nzZIndex="100">
  <ng-container *nzModalContent>
    <div *ngIf="modalPreview">
      <!-- <pdf-viewer [src]="previewDataStream" [render-text]="false" style="display: block; min-width:640px">
      </pdf-viewer> -->
      <ngx-extended-pdf-viewer [src]="previewDataStream" useBrowserLocale="true" style="display: block; min-width:840px"></ngx-extended-pdf-viewer>
    </div>
  </ng-container>
</nz-modal>


<!-- <nz-modal
  nzTitle="Preview"
  [nzVisible]="modalPDFpreview"
  [nzStyle]="{ top: '0px', width: '100vw', height: '100vh' }"
  [nzBodyStyle]="{ height: 'calc(100vh - 55px)', overflow: 'hidden' }"
  [nzWidth]="'100%'" [nzFooter]="null" (nzOnCancel)="modalPDFpreview=false" (nzOnOk)="modalPDFpreview=false"
> -->
  <!-- <div class="grid grid-gap-10 grid-2x grid-2x-responsive">
    <div>
      <span class="text-a-center d-b"><h6>Preview</h6></span>
      <div style="height: 80vh; overflow-y: scroll; max-width: 50%">
        <pdf-viewer [src]="previewDataStream" [render-text]="false" style="display: block;">
        </pdf-viewer>
      </div>
    </div>
    <div>
      <span class="text-a-center d-b"><h6>Worksheet</h6></span>
      <div style="height: 80vh; overflow-y: scroll; ; max-width: 50%">
        <app-ui-worksheet [IO]="_IO" transactionState="transactionState"></app-ui-worksheet>
      </div>
    </div>
  </div> -->

  <!-- <div style="height: 80vh; overflow-y: scroll; max-width: 100%">
    <nz-tabset>
      <nz-tab nzTitle="PDF Preview">
        <pdf-viewer [src]="previewDataStream" [render-text]="false" style="display: block;">
        </pdf-viewer>
      </nz-tab>
      <nz-tab nzTitle="Worksheet">
        <app-ui-worksheet [IO]="_IO" transactionState="transactionState" style="width:100%"></app-ui-worksheet>
      </nz-tab>
    </nz-tabset>

  </div> -->

<!-- </nz-modal> -->


